export const QUERY_PARAM_SEARCH_BUTTON_CLICKED = 'search-button-clicked';
export const QUERY_PARAM_WELCOME = 'welcome';
export const QUERY_PARAM_SEARCH = 'search';
export const QUERY_PARAM_SORT = 'sort';
export const QUERY_SELECTED_STATUSES = 'selected-statuses';
export const OFFER_SHOULD_REFRESH = 'offer-should-refresh';
export const OFFER_IS_LOADING = 'offer-is-loading';
export const OFFER_IS_REJECTED = 'offer-status=Denied';
export const OFFER_IS_ACCEPTED = 'offer-status=Accepted';
export const VERIFY_OTP_MODAL = 'verify-otp-modal';
export const OTP_SENDING_ERROR = 'otp-sending-error';
export const OTP_SENT = 'otp-sent';
export const CART_SHOULD_BE_REFRESHED = 'cart-should-refresh';
export const CART_PRICE_HAS_CHANGED = 'cart-price-has-changed';
export const CART_PDP_PRICE_UPDATED = 'cart-pdp-price-updated';
export const CART_PDP_PRICE_LOADING_ISSUE = 'cart-pdp-price-loading-issue';
export const CART_PDP_PRICE_CALCULATION_UNAVAILABLE = 'cart-pdp-price-calculation-unavailable';
export const COPIED_TO_CLIPBOARD = 'copied-to-clipboard';
export const CART_CHECKOUT_PRICE_GOT_UPDATED = 'cart-checkout-price-got-updated';
export const CART_CHECKOUT_PROCESS_ERROR = 'cart-checkout-process-error';
export const IMPERSONATING_ACCOUNT = 'impersonating_account';
export const USER_FIRST_NAME = 'user_firstName';
export const USER_LAST_NAME = 'user_lastName';
export const CHANGES_SAVED = 'changes-saved';
export const ADDRESS_UPDATED = 'address-updated';
export const ERROR_HAS_HAPPENED = 'error-has-happened';
export const ERROR_MESSAGE = 'error-message';
export const ERROR_OCCURRED_WHILE_UPDATING = 'error-occurred-while-updating';
export const ERROR_DOWNLOADING_INVOICE = 'error-downloading-invoice';
export const HAS_SEEN_MODAL = 'hasSeenModal';
export const QUERY_PARAM_FULFILLMENT_EVENT_ID = 'fulfillment_event_id';
export const QUERY_PARAM_CATEGORY = 'category';
export const OFFER_HAS_UPDATED_MODAL = 'offer-has-updated-modal';
export const IS_WEEK_PICKER_MODAL_OPEN = 'isWeekPickerModalOpen';
export const IS_CHANGE_ADDRESS_MODAL_OPEN = 'isChangeAddressModalOpen';
export const QUERY_PARAM_FINANCING_PLAN = 'selected-fp'; // selected financing plan
export const QUERY_PARAM_FINANCING_PLAN_AMOUNT = 'selected-fpa'; // selected financing plan amount
export const QUERY_PARAM_VIEW_SUMMARY = 'view-summary';
export const QUERY_PARAM_CATEGORY_ID = 'categoryId';
export const QUERY_PARAM_QUERY = 'query';
export const QUERY_PARAM_SHOW_MORE_DETAILS = 'showMoreDetails';
export const QUERY_PARAM_CONFIRM_ORDER_PLACE_FAILED = 'COP-failed'; // Confirm Order Place failed
export const QUERY_PARAM_CONFIRM_ORDER_PLACE_CLICKED = 'COP-clicked'; // Confirm Order Place clicked
export const SEARCH_PARAM_SELECTED_UNIT = 'unit';
export const SEARCH_PARAM_SELECTED_QUANTITY = 'quantity';
export const SEARCH_PARAM_SELECTED_WEEK = 'week';
export const SEARCH_PARAM_SHOW_ALL_WEEKS = 'show-all-weeks';
export const SEARCH_PARAM_ERROR_TEXT = 'error-text';
export const SEARCH_PARAM_CART_UPDATED = 'cart-updated';
export const ITEM_QUANTITY_HAS_CHANGED = 'item-quantity-has-changed';
export const ENTERED_QUANTITY_IS_OVER_AVAILABLE_QUANTITY =
  'entered-quantity-is-over-available-quantity';
export const ITEM_DELIVERY_DATE_HAS_CHANGED = 'item-delivery-date-has-changed';
export const ITEM_HAS_BEEN_REMOVED = 'item-has-been-removed';
export const ITEM_HAS_BEEN_ADDED_TO_CART = 'item-has-been-added-to-cart';
export const ITEM_HAS_BEEN_MERGED = 'item-has-been-merged';
export const ITEM_CAN_NOT_MERGE = 'item-can-not-merge';
export const PRODUCT_ID = 'product-id';
export const UNITS_PER_PALLET = 'units-per-pallet';
export const REQUEST_A_QUOTE_MODAL = 'request-a-quote-modal';
export const REQUEST_A_QUOTE_DELIVERY_DATE = 'request-a-quote-delivery-date';
export const REQUEST_HAS_BEEN_SENT = 'request-has-been-sent';
export const REQUEST_SENT_TO_ACCOUNT_EXECUTIVE = 'request-sent-to-account-executive';
export const PASSWORD_CHANGE_SUCCESS = 'password-change-success';
export const PASSWORD_CREATE_SUCCESS = 'password-create-success';
export const PDP_RIGHT_SIDE_MODAL = 'pdp-right-side-modal';
export const INVOICE_DETAILS_MODAL = 'invoice-details-modal';
export const INVOICE_ID = 'invoice-id';
export const PDP_DATA_SHEET = 'pdp-data-sheet';
export const PDP_DIMENSIONS = 'pdp-dimensions';
export const PDP_PRODUCT_DETAILS = 'pdp-product-details';
export const PRICE_CALCULATION_DETAIL = 'pricing-calculation-details';
export const REPORT_CASE_MODAL = 'report-case-modal';
export const PREVIOUS_STEP = 'previous-step';
export const STEP = 'step';
export const POSTING_REPORT_CASE = 'posting-report-case';
export const CATEGORY = 'category';
export const ANDERCORE_ID = 'andercore_id';
export const FULFILLMENT_EVENT_ID = 'fulfillment_event_id';
export const SEARCH_PARAM_BNPL_OPTIONS_MODAL = 'bnpl-options-modal';
export const SEARCH_PARAM_BNPL_RESOURCE_TYPE = 'bnpl-resource-type'; // quote | order | fulfillmentEvent
export const SEARCH_PARAM_BNPL_RESOURCE_ID = 'bnpl-resource-id';
export const SEARCH_PARAM_BNPL_ORDER_AMOUNT = 'bnpl-amount';
export const SEARCH_PARAM_BNPL_OWNER_ID = 'bnpl-owner-id';
export const SEARCH_PARAM_BNPL_ANDERCORE_ID = 'bnpl-andercore-id';
export const SEARCH_PARAM_BNPL_CURRENCY = 'bnpl-currency';
